import { OpravnenieEnum, UserApi, UserDetail } from 'tezaury-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import CurrentUserDetail from '../../model/currentuser/CurrentUserDetail';
import UserRole from '../../model/currentuser/UserRole';

const client = new UserApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchCurrentPouzivatel = async (options?: { headers?: never }): Promise<ClientResponse<UserDetail>> => {
  const {
    data,
    status,
  } = await client.getCurrentUser(options);

  return {
    data: map(data),
    responseCode: status,
  };
};

const map = (data: UserDetail): CurrentUserDetail => ({
  meno: data.meno,
  uuid: data.uuid,
  organizaciaNazov: data.organizaciaNazov,
  organizaciaUuid: data.organizaciaUuid,
  roles: mapOpravnenieEnumList(data.opravnenieList),
});

const mapOpravnenieEnumList = (opravnenieList: OpravnenieEnum[]): UserRole[] => (
  !opravnenieList ? [] : opravnenieList.map(opravnenie => UserRole[opravnenie])
);
